module.exports = __webpack_public_path__ + "img/detail.770d9c1e.svg";